import { logout } from './authApi';

let isLoggingOut = false;

export async function apiClient(url, options = {}) {
    const response = await fetch(url, options);

    if (response.status === 401 && !isLoggingOut && window.location.pathname !== '/login') {
        // If we get a 401, it means the session has expired
        isLoggingOut = true;
        await logout();
        const error = new Error('Unauthorized');
        error.name = 'HttpError';
        error.status = 401;
        throw error;
    }

    if (response.status === 403) {
        const error = new Error('Forbidden');
        error.name = 'HttpError';
        error.status = 403;
        throw error;
    }

    if (!response.ok) {
        let errorMessage = `Request failed with status ${response.status}`;
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            try {
                // We clone the response to be able to read it multiple times if needed, 
                // though here we are throwing an error so it might not be strictly necessary
                // but it's good practice.
                const errorData = await response.clone().json();
                if (errorData && errorData.detail) {
                    errorMessage = errorData.detail;
                }
            } catch (e) {
                // Fallback to default message if JSON parsing fails
            }
        }
        const error = new Error(errorMessage);
        error.name = 'HttpError';
        error.status = response.status;
        error.response = response;
        throw error;
    }

    return response;
}
